module.exports = __webpack_public_path__ + "03_short_grey.4e166d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_short_grey.png
// module id = mcSc
// module chunks = 0